import { Reveal } from "@/components/site/motion";
import { MANIFESTO } from "@/data/content";

const Manifesto = () => (
  <section id="approach" className="relative bg-sand2 py-24 md:py-36 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-10 mb-20">
        <Reveal className="md:col-span-7">
          <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Why New Beginnings</p>
          <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02]">
            Your healing is just the start of a <span className="italic text-terracotta">whole new life</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-5 self-end">
          <p className="text-ink2 text-lg leading-relaxed">
            New Beginnings Recovery Home provides integrated inpatient treatment for drug and alcohol
            addiction and co-occurring mental health disorders such as PTSD, depression and anxiety — delivered
            by a licensed, accredited, multidisciplinary team in an immersive, round-the-clock care environment.
          </p>
        </Reveal>
      </div>

      <div className="space-y-0">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.1}>
            <div className="grid md:grid-cols-12 gap-6 items-baseline py-10 border-t border-line">
              <span className="md:col-span-2 font-serif text-6xl md:text-7xl text-sage/70 leading-none">{m.n}</span>
              <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl text-forest">{m.title}</h3>
              <p className="md:col-span-6 text-ink2 text-lg leading-relaxed">{m.body}</p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-line" />
      </div>
    </div>
  </section>
);

export default Manifesto;
